import { ColOptWrapper, DropdownCtaWithTooltip } from "./DropdownOptionCTA.styles";
import { type JSX } from "react";
import { V3BodyGrey35 } from "../ReusableStyledComponents/V3BodyGrey35";
import { V3Tooltip } from "../Tooltip";
import { V3IconHelpCircle } from "../Icons";
import { theme } from "../../theme/theme";

export enum V3DropdownCTAColor {
    color = "color",
    red = "red"
}

export interface AgnosticDropdownOptionCTAProps {
    icon?: JSX.Element;
    label?: string;
    variant?: V3DropdownCTAColor;
    onClick?: () => void;
    active?: boolean;
    skipSVGActiveEffect?: boolean;
    justifiedCentered?: boolean;
    id?: string;
    tabIndex?: number;
    customLabelElement?: JSX.Element;
    disabled?: boolean;
    tooltipContent?: string | JSX.Element;
    tooltipMaxWidth?: number;
}

export const AgnosticDropdownCTA = ({
    label,
    icon,
    variant = V3DropdownCTAColor.color,
    onClick,
    active = false,
    skipSVGActiveEffect = false,
    justifiedCentered = false,
    id,
    tabIndex,
    customLabelElement,
    disabled = false,
    tooltipContent,
    tooltipMaxWidth = 240
}: AgnosticDropdownOptionCTAProps) => (
    <ColOptWrapper
        key={label}
        $variant={variant}
        $disabled={disabled}
        onClick={disabled ? undefined : onClick}
        $active={active}
        $skipSVGActiveEffect={skipSVGActiveEffect}
        $justifiedCentered={justifiedCentered}
        id={id}
        tabIndex={tabIndex}
        onKeyPress={(e) => {
            if (e.key === "Enter") {
                onClick && onClick();
            }
        }}
    >
        {!!icon && <div>{icon}</div>}
        {!!customLabelElement && <>{customLabelElement}</>}
        {!!label && !!label.length && (
            <DropdownCtaWithTooltip>
                <V3BodyGrey35>{label}</V3BodyGrey35>
                {!!tooltipContent && (
                    <div>
                        <V3Tooltip
                            tooltipMaxWidth={tooltipMaxWidth}
                            referenceContent={<V3IconHelpCircle stroke={theme.v3.colors.grey48} strokeWidth={"1.2"} />}
                            tooltipContent={tooltipContent}
                        />
                    </div>
                )}
            </DropdownCtaWithTooltip>
        )}
    </ColOptWrapper>
);
